// extracted by mini-css-extract-plugin
export default {"values":"Values_values__aeF-+","value":"Values_value__kHqv+"};